import React, { useEffect, useState } from 'react';
import { Divider, FormControlLabel, Radio, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { FormInputCheckbox } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputCheckbox';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputDatePicker } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDatePicker';
import { useSelector } from 'react-redux';
import {
  selectIslandsCancel,
  selectPlacementHeaderData,
  selectPlacementLandsGtgDetails,
} from '../../../../../../../store/redux-store/placement-details/selectors';
const useStyles = makeStyles()((theme: Theme) => ({
  alingmentField: {
    paddingLeft: '6px !important',
    paddingRight: '25px !important',
  },
  sectionTitle: {
    paddingBottom: '6px',
    paddingTop: '6px',
  },
  subTitleStyle: {
    fontWeight: 'bold',
  },
  alignItem: {
    paddingLeft: '18px !important',
  },
  itemStyle: {
    paddingTop: '22px !important',
    height: '215px',
  },
}));
export const CredentialingReview = props => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const selectLandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const selectiscancel = useSelector(selectIslandsCancel);
  const placementHeaderInfo = useSelector(selectPlacementHeaderData);
  const [allVerified, setAllVerified] = useState<boolean>(selectLandsGtgDetails?.allCertificationsVerified || false);
  const [eventsSet, setEventsSet] = useState<boolean>(selectLandsGtgDetails?.missExpEvents || false);
  const [currentClientYes, setCurrentClientYes] = useState<boolean>(selectLandsGtgDetails?.packetNotRequired || false);
  const [currentClientNo, setCurrentClientNo] = useState<boolean>(
    selectLandsGtgDetails?.packetNotRequired === false
      ? !selectLandsGtgDetails?.packetNotRequired
      : placementHeaderInfo.facility.amnDivisionTypeId === 6,
  );
  const [currentYes, setCurrentYes] = useState<boolean>(selectLandsGtgDetails?.noExpAssign || false);
  const [currentNo, setCurrentNo] = useState<boolean>(!selectLandsGtgDetails?.noExpAssign || false);
  const { getValues, setValue, control } = useFormContext();
  useEffect(() => {
    setValue('pExpYes', selectLandsGtgDetails?.noExpAssign || false);
    setValue('pEventsSet', selectLandsGtgDetails?.missExpEvents);
    setValue('pAllVerified', selectLandsGtgDetails?.allCertificationsVerified || false);
    setValue(
      'pClientYes',
      selectLandsGtgDetails?.packetNotRequired ||
        (placementHeaderInfo.facility.amnDivisionTypeId !== 6 && selectLandsGtgDetails?.packetNotRequired !== false) ||
        false,
    );
    setValue('pSentToClient', selectLandsGtgDetails?.packetSentDate);
    setCurrentYes(selectLandsGtgDetails?.noExpAssign || false);
    setCurrentNo(!selectLandsGtgDetails?.noExpAssign || false);
    //If division is HSG, [Client require credentialing packet?] checkbox is automaticallly checked to No
    if (placementHeaderInfo.facility.amnDivisionTypeId === 6) {
      selectLandsGtgDetails?.packetNotRequired === null
        ? setCurrentClientYes(true)
        : setCurrentClientYes(selectLandsGtgDetails?.packetNotRequired || false);
    } else {
      setCurrentClientYes(selectLandsGtgDetails?.packetNotRequired || false);
    }
    setCurrentClientNo(
      selectLandsGtgDetails?.packetNotRequired === true
        ? !selectLandsGtgDetails?.packetNotRequired
        : placementHeaderInfo.facility.amnDivisionTypeId === 6,
    );
    setAllVerified(selectLandsGtgDetails?.allCertificationsVerified || false);
    setEventsSet(selectLandsGtgDetails?.missExpEvents || false);
  }, [placementHeaderInfo.facility.amnDivisionTypeId, selectLandsGtgDetails, selectiscancel, setValue]);

  const handleEventsSet = event => {
    setValue('pEventsSet', event, { shouldDirty: true });
    setEventsSet(event);
    props.handleFieldChanges?.();
  };
  const handleAllVerified = event => {
    setValue('pAllVerified', event, { shouldDirty: true });
    setAllVerified(event);
    props.handleFieldChanges?.();
  };
  const handleSentToClient = event => {
    setValue('pSentToClient', event, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  return (
    <>
      <LayoutGrid container direction="column" spacing={0}>
        <LayoutGridItem item className={classes.sectionTitle}>
          <Typography variant="subtitle1" component="div" className={classes.subTitleStyle}>
            {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.credentialingReview.title')}
          </Typography>
        </LayoutGridItem>
        <Divider variant="middle" />
        <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyle}`}>
          <LayoutGrid container direction="row" data-testid="container" justifyContent="flex-start" spacing={4}>
            <LayoutGridItem item xs={8} className={classes.alingmentField}>
              <Typography component="span">
                {t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.credentialingReview.expirationEventsExistWithinAssignmentDuration',
                )}
              </Typography>
              <LayoutGrid direction="column">
                <LayoutGridItem>
                  <Controller
                    name="pExpYes"
                    key={'yes'}
                    control={control}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <FormControlLabel
                        name="pExpYes"
                        key={'yes'}
                        control={
                          <Radio
                            checked={currentYes}
                            disabled={!props.hasEditPermission}
                            onChange={e => {
                              setCurrentYes(!currentYes);
                              setCurrentNo(false);
                              setValue('pExpNo', false, { shouldDirty: true });
                              setValue('pExpYes', !currentYes, { shouldDirty: true });
                              props.handleFieldChanges?.();
                            }}
                          />
                        }
                        label={t('global.Yes')}
                      />
                    )}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <Controller
                    key={'no'}
                    name="pExpNo"
                    control={control}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <FormControlLabel
                        key={'no'}
                        name="pExpNo"
                        control={
                          <Radio
                            checked={currentNo}
                            disabled={!props.hasEditPermission}
                            onChange={e => {
                              setCurrentNo(!currentNo);
                              setCurrentYes(false);
                              setEventsSet(false);
                              setValue('pExpNo', !currentNo, { shouldDirty: true });
                              setValue('pExpYes', false, { shouldDirty: true });
                              setValue('pEventsSet', false, { shouldDirty: true });
                              props.handleFieldChanges?.();
                            }}
                          />
                        }
                        label={t('global.No')}
                      />
                    )}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="pEventsSet"
                    isChecked={eventsSet}
                    handleChecked={handleEventsSet}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.credentialingReview.missingExpiringEventsSet',
                    )}
                    isDisabled={!props.hasEditPermission || currentNo}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="pAllVerified"
                    isChecked={allVerified}
                    handleChecked={handleAllVerified}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.credentialingReview.allCertificationsVerified',
                    )}
                    isDisabled={!props.hasEditPermission}
                  />
                </LayoutGridItem>
              </LayoutGrid>
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
        <LayoutGridItem item className={classes.alignItem}>
          <LayoutGrid container direction="row" data-testid="container" justifyContent="flex-start" spacing={4}>
            <LayoutGridItem item xs={6} className={classes.alingmentField}>
              <Typography component="span">
                {t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.credentialingReview.doesClientRequireCredentialingPacket',
                )}
              </Typography>
              <LayoutGrid direction="column">
                <LayoutGridItem>
                  <Controller
                    name="pClientYes"
                    key={'yes'}
                    control={control}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <FormControlLabel
                        name="pClientYes"
                        key={'yes'}
                        control={
                          <Radio
                            checked={!currentClientYes}
                            disabled={!props.hasEditPermission}
                            onChange={e => {
                              setCurrentClientYes(false);
                              setCurrentClientNo(false);
                              setValue('pClientNo', false);
                              setValue('pClientYes', false, { shouldDirty: true });
                              props.handleFieldChanges?.();
                            }}
                          />
                        }
                        label={t('global.Yes')}
                      />
                    )}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputDatePicker
                    name={'pSentToClient'}
                    label={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.credentialingReview.dateSentToClient',
                    )}
                    handleChange={handleSentToClient}
                    require={false}
                    readOnly={!props.hasEditPermission || currentClientYes}
                    inputValue={getValues('pSentToClient')}
                    trailingIconVisible={true}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <Controller
                    key={'no'}
                    name="pClientNo"
                    control={control}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <FormControlLabel
                        key={'no'}
                        name="pClientNo"
                        control={
                          <Radio
                            checked={currentClientYes}
                            disabled={!props.hasEditPermission}
                            onChange={e => {
                              setValue('pSentToClient', null, { shouldDirty: true });
                              setCurrentClientNo(true);
                              setCurrentClientYes(true);
                              setValue('pClientNo', !currentClientNo, { shouldDirty: true });
                              setValue('pClientYes', true, { shouldDirty: true });
                              props.handleFieldChanges?.();
                            }}
                          />
                        }
                        label={t('global.No')}
                      />
                    )}
                  />
                </LayoutGridItem>
              </LayoutGrid>
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
      </LayoutGrid>
    </>
  );
};
